import {
	endOfMonth,
	endOfQuarter,
	lastDayOfQuarter,
	endOfYear,
	format,
	getYear,
	startOfMonth,
	startOfQuarter,
	subDays,
	subBusinessDays,
	subWeeks,
	subMonths,
	subQuarters,
	addBusinessDays,
} from "date-fns";
import { DateType } from "./types/types";

const getFormattedDate = (
	dateType: keyof DateType,
	currentDate: Date = new Date(),
	numberOfPeriodsAgo: number = 0,
	showMonthName: boolean = false,
	showLeadingZero: boolean = false,
	showAbbreviatedName: boolean = false,
	showMonthDay: boolean = false,
) => {
	const dates: DateType = {
		currentYear: getYear(currentDate),
		previousCompletedQuarterEnd: lastDayOfQuarter(
			subQuarters(currentDate, 1),
		),
		previousCompletedQuarterStart: startOfQuarter(
			subQuarters(currentDate, 1),
		),
		endOfPreviousQuarter: endOfQuarter(currentDate),
		previousYear: getYear(currentDate) - 1,
		xYearsAgo: getYear(currentDate) - numberOfPeriodsAgo,
		xYearsForward: getYear(currentDate) + numberOfPeriodsAgo,
		nextYear: getYear(currentDate) + 1,
		today: currentDate,
		yesterday: subDays(currentDate, 1),
		previousBusinessDay: subBusinessDays(currentDate, 1),
		nextBusinessDay: addBusinessDays(currentDate, numberOfPeriodsAgo),
		xDaysAgo: subDays(currentDate, numberOfPeriodsAgo),
		xWeeksAgo: subWeeks(currentDate, numberOfPeriodsAgo),
		xMonthsAgo: subMonths(currentDate, numberOfPeriodsAgo),
		endOfYear: endOfYear(currentDate),
		startMonth: startOfMonth(currentDate),
		endOfMonth: endOfMonth(currentDate),
		endOfPreviousMonth: endOfMonth(subMonths(currentDate, 1)),
	};

	const needsDateFormat = typeof dates[dateType] !== "number";

	if (showMonthName) {
		return format(dates[dateType], "MMMM d, yyyy");
	}
	if (showMonthDay) {
		return format(dates[dateType], "MM/dd");
	}
	if (showLeadingZero) {
		return format(dates[dateType], "MM/dd/yyyy");
	}
	if (showAbbreviatedName) {
		return format(dates[dateType], "MMM d, yyyy");
	} else {
		return needsDateFormat
			? format(dates[dateType], "M/d/yyyy")
			: dates[dateType];
	}
};

export default getFormattedDate;
